import React, { useState, useEffect } from 'react'
import { Button, Col, Container, Form, Row, Spinner } from 'react-bootstrap'
import axios from 'axios'
import toast, { Toaster } from 'react-hot-toast';
import Select from 'react-select'
import { Input } from 'rsuite'
import { useSelector } from 'react-redux';

function AddAffliate() {
    const StoreUser = useSelector((state) => state.user);
    const [affloading, setaffloading] = useState(false);
    const [affliate, setAffliate] = useState({});
    const [formAffiliate, setFormAffiliate] = useState({
        username: "",
        password: "",
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        messenger: 0,
        messengerusername: "",
        website: "",
        country: "",
        language: 1,
        currency: 4,
        commissiongroup: 0,
        affiliategroup: 0,
        note: ""
    })
    const [errorCode, setErroCode] = useState("")
    const [validation, setValidation] = useState({
        username: null,
        password: null,
        firstname: null,
        lastname: null,
        email: null,
        phone: null,
        messenger: null,
        messengerusername: null,
        website: null,
        country: null,
        commissiongroup: null,
        affiliategroup: null,
    })
    const [ltComGrp, setLtComGrp] = useState([])
    const [ltAffGrp, setLtAffGrp] = useState([])
    const [ltLang, setLtLang] = useState([])
    const [ltMesg, setLtMesg] = useState([])
    const [ltCount, setLtCount] = useState([])
    const [affliatePermission, setAffliatePermission] = useState(false)

    const addAffiliate = async () => {
        var initValidation = {
            username: null,
            password: null,
            firstname: null,
            lastname: null,
            email: null,
            phone: null,
            messenger: null,
            messengerusername: null,
            website: null,
            country: null,
            commissiongroup: null,
            affiliategroup: null,
        }
        var errored = false;
        if (formAffiliate.username == "") {
            initValidation.username = "Username field is required !"
            errored = true
        }
        if (formAffiliate.password == "") {
            initValidation.password = "Password field is required !"
            errored = true
        }
        if (formAffiliate.firstname == "") {
            initValidation.firstname = "Firstname field is required !"
            errored = true
        }
        if (formAffiliate.lastname == "") {
            initValidation.lastname = "Lastname field is required !"
            errored = true
        }
        if (formAffiliate.email == "") {
            initValidation.email = "Email field is required !"
            errored = true
        }
        if (formAffiliate.phone == "") {
            initValidation.phone = "Phone field is required ! "
            errored = true
        }
        if (formAffiliate.messenger == 0) {
            initValidation.messenger = "Messenger field is required !"
            errored = true
        }
        if (formAffiliate.messengerusername == "") {
            initValidation.messengerusername = "Messenger Username field is required !"
            errored = true
        }
        if (formAffiliate.country == "") {
            initValidation.country = "Country field is required !"
            errored = true
        }
        if (formAffiliate.commissiongroup == 0) {
            initValidation.commissiongroup = "Commission group field is required !"
            errored = true
        }
        if (formAffiliate.affiliategroup == 0) {
            initValidation.affiliategroup = "Affiliate group field is required !"
            errored = true
        }
        if (formAffiliate.website == "") {
            initValidation.website = "Website field is required !"
            errored = true
        }
        setValidation(initValidation);
        if (errored) {
            return toast.error("Missing Information");
        }

        setaffloading(true);

        const response = await axios.post(window.__CFG.API + "affiliates/AddAffiliate", formAffiliate, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })

        setaffloading(false);

        if (response.data.Error == null) {
            toast.success("Saved Sucessufully", {
                duration: 4000
            });
            setFormAffiliate({
                username: "",
                password: "",
                firstname: "",
                lastname: "",
                email: "",
                phone: "",
                messenger: 0,
                messengerusername: "",
                website: "",
                country: "",
                language: 1,
                currency: 4,
                commissiongroup: 0,
                affiliategroup: 1,
                note: ""
            })
        }
        else {
            toast.error(response.data.Error, {
                duration: 4000
            })
            if (response.data.Code) {
                setErroCode(response.data.Code)
            }
        }
    }
    const checkPermission = (user, permission) => {
        var Permissions = user.Permissions;
        if (Permissions && Permissions.length > 0) {
            const index = Permissions.findIndex(per => per === permission)
            if (index != -1) return true;
            else return false;
        }
        return true
    }
    const getListAffliateGrp = async () => {
        const response = await axios.get(window.__CFG.API + "manager/ListAllAffiliateGroups", {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        if (response.data.Error === null) {
            setLtAffGrp(response.data.Result)
        }
    }
    const getListCommissionGrp = async () => {
        const response = await axios.get(window.__CFG.API + "manager/ListAllCommissionGroups", {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        if (response.data.Error === null) {
            setLtComGrp(response.data.Result)
        }
    }
    const getListLanguages = async () => {
        const response = await axios.get(window.__CFG.API + "manager/ListAllLanguages", {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        if (response.data.Error === null) {
            setLtLang(response.data.Result)
        }
    }
    const getListMessenger = async () => {
        const response = await axios.get(window.__CFG.API + "manager/ListAllMessengers", {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        if (response.data.Error === null) {
            setLtMesg(response.data.Result)
        }
    }
    const getListCountries = async () => {
        const response = await axios.get(window.__CFG.API + "manager/ListAllCountries", {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        if (response.data.Error === null) {
            setLtCount(response.data.Result)
        }
    }
    useEffect(() => { getListAffliateGrp(); getListCommissionGrp(); getListLanguages(); getListMessenger(); getListCountries() }, [])
    useEffect(() => {
        if (StoreUser != undefined) {
            setAffliate(StoreUser.User)
        }
    }, [affliate])
    useEffect(() => { setAffliatePermission(checkPermission(affliate, "aff_add_affiliate")) }, [affliate])

    const optionsCurrency = [{ label: "USD", value: 1 }]
    const Textarea = React.forwardRef((props, ref) => <Input {...props} as="textarea" ref={ref} />);
    const selectedCurrencyValue = optionsCurrency.find(option => option.value === 1)

    return (
        <>
            <div>
                <div>
                    {/* <CustomNavbar /> */}
                </div>

                <div>

                    <Container>

                        <Row >

                            <Row style={{ marginTop: 10, paddingBottom: 10, }} className="justify-content-between mt-4 me-auto w-75 form-add-aff"  >
                                <Col lg={4} md={4} sm={4}>
                                    <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                                        <label>Username (login)</label>
                                    </div>
                                    <Form.Control value={formAffiliate.username} disabled={!affliatePermission} className={errorCode === "username_exists" || validation.username != null ? ("error-form-add") : ("")} onChange={e => setFormAffiliate({ ...formAffiliate, username: e.target.value })} style={{ width: "100%", padding: 4, borderColor: "rgba(0, 0, 0, 0.2)", borderRadius: 3 }} />
                                    {
                                        validation.username !== null ? (
                                            <div class="invalid-feedback loginForm">
                                                {validation.username}
                                            </div>
                                        ) : (
                                            <></>
                                        )
                                    }
                                </Col>
                                <Col lg={4} md={4} sm={5} style={{ width: "100%" }}>
                                </Col>
                            </Row>
                            <Row style={{ marginTop: 10, paddingBottom: 10 }} className="justify-content-start mt-4 me-auto w-75 form-add-aff">
                                <Col lg={4} md={4} sm={4}>
                                    <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                                        <label>Password</label>
                                    </div>
                                    <Form.Control type="password" disabled={!affliatePermission} value={formAffiliate.password} className={errorCode === "password_wrong_format" || validation.password != null ? ("error-form-add") : ("")} onChange={e => setFormAffiliate({ ...formAffiliate, password: e.target.value })} style={{ width: "100%", padding: 4, borderColor: "rgba(0, 0, 0, 0.2)", borderRadius: 3 }} />

                                    {
                                        validation.password !== null ? (
                                            <div class="invalid-feedback loginForm">
                                                {validation.password}
                                            </div>
                                        ) : (
                                            <></>
                                        )
                                    }
                                </Col>
                                <Col lg={4} md={4} sm={5}>
                                    <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                                        <label> Repeat Password</label>
                                    </div>
                                    <Form.Control disabled={!affliatePermission} className={errorCode === "password_wrong_format" || validation.password != null ? ("error-form-add") : ("")} type="password" style={{ width: "100%", padding: 4, borderColor: "rgba(0, 0, 0, 0.2)", borderRadius: 3 }} />
                                </Col>
                            </Row>

                            <Row style={{ marginTop: 10, paddingBottom: 10 }} className="justify-content-start mt-1 me-auto w-75 form-add-aff">
                                <Col lg={4} md={4} sm={4}>
                                    <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                                        <label>Affiliate name </label>
                                    </div>
                                    <Form.Control type="text" disabled={!affliatePermission} value={formAffiliate.firstname} className={validation.firstname != null ? ("error-form-add") : ("")} onChange={e => setFormAffiliate({ ...formAffiliate, firstname: e.target.value })} style={{ width: "100%", padding: 4, borderColor: "rgba(0, 0, 0, 0.2)", borderRadius: 3 }} />
                                    {
                                        validation.firstname !== null ? (
                                            <div class="invalid-feedback loginForm">
                                                {validation.firstname}
                                            </div>
                                        ) : (
                                            <></>
                                        )
                                    }
                                </Col>
                                <Col lg={4} md={4} sm={5}>
                                    <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                                        <label>Surname</label>
                                    </div>
                                    <Form.Control type="text" disabled={!affliatePermission} value={formAffiliate.lastname} className={validation.firstname != null ? ("error-form-add") : ("")} onChange={e => setFormAffiliate({ ...formAffiliate, lastname: e.target.value })} style={{ width: "100%", padding: 4, borderColor: "rgba(0, 0, 0, 0.2)", borderRadius: 3 }} />

                                    {
                                        validation.lastname !== null ? (
                                            <div class="invalid-feedback loginForm">
                                                {validation.lastname}
                                            </div>
                                        ) : (
                                            <></>
                                        )
                                    }
                                </Col>
                                {/* <div style={{ borderBottom: "1px dashed black", marginTop: "30px", width: "400px" }}></div> */}

                            </Row>
                            <Row style={{ marginTop: 10, paddingBottom: 10 }} className="justify-content-start mt-1 me-auto w-75 form-add-aff">
                                <Col lg={4} md={4} sm={4}>
                                    <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                                        <label>Email Adress</label>
                                    </div>
                                    <Form.Control type="email" disabled={!affliatePermission} value={formAffiliate.email} className={errorCode === "email_exists" || validation.email != null ? ("error-form-add") : ("")} onChange={e => setFormAffiliate({ ...formAffiliate, email: e.target.value })} style={{ width: "100%", padding: 4, borderColor: "rgba(0, 0, 0, 0.2)", borderRadius: 3 }} />

                                    {
                                        validation.email !== null ? (
                                            <div class="invalid-feedback loginForm">
                                                {validation.email}
                                            </div>
                                        ) : (
                                            <></>
                                        )
                                    }
                                </Col>
                                <Col lg={4} md={4} sm={5}>
                                    <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                                        <label>Phone number</label>
                                    </div>
                                    <Form.Control type="text" disabled={!affliatePermission} value={formAffiliate.phone} className={errorCode === "phone_exists" || validation.phone != null ? ("error-form-add") : ("")} onChange={e => setFormAffiliate({ ...formAffiliate, phone: e.target.value })} style={{ width: "100%", padding: 4, borderColor: "rgba(0, 0, 0, 0.2)", borderRadius: 3 }} />
                                    {
                                        validation.phone !== null ? (
                                            <div class="invalid-feedback loginForm">
                                                {validation.phone}
                                            </div>
                                        ) : (
                                            <></>
                                        )
                                    }
                                </Col>
                            </Row>
                            <Row style={{ marginTop: 10, paddingBottom: 10 }} className="justify-content-start mt-1 me-auto w-75 form-add-aff">
                                <Col lg={4} md={4} sm={4}>
                                    <div className='form-aff-list-in'>
                                        <div style={{ marginBottom: 3 }} className='form-aff-list-in-lab'>
                                            <label>Messenger</label>
                                        </div>
                                        <div className="dashboard-select-periode" style={{ maxWidth: "100%" }}>
                                            <Select options={ltMesg} onChange={e => setFormAffiliate({ ...formAffiliate, messenger: e.value })} isDisabled={!affliatePermission} />
                                        </div>
                                        {
                                            validation.messenger !== null ? (
                                                <div class="invalid-feedback loginForm">
                                                    {validation.messenger}
                                                </div>
                                            ) : (
                                                <></>
                                            )
                                        }
                                    </div>
                                </Col>
                                <Col lg={4} md={4} sm={5}>
                                    <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                                        <label>Messenger Username</label>
                                    </div>
                                    <Form.Control disabled={!affliatePermission} type="text" value={formAffiliate.messengerusername} className={validation.messengerusername != null ? ("error-form-add") : ("")} onChange={e => setFormAffiliate({ ...formAffiliate, messengerusername: e.target.value })} style={{ width: "100%", padding: 4, borderColor: "rgba(0, 0, 0, 0.2)", borderRadius: 3 }} />
                                    {
                                        validation.messengerusername !== null ? (
                                            <div class="invalid-feedback loginForm">
                                                {validation.messengerusername}
                                            </div>
                                        ) : (
                                            <></>
                                        )
                                    }
                                </Col>
                            </Row>
                            <Row style={{ marginTop: 10, paddingBottom: 10 }} className="justify-content-start mt-4 me-auto w-75 form-add-aff">
                                <Col lg={8} md={4} sm={4}>
                                    <Form >
                                        <Form.Group className="text-start">
                                            <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                                                <label>Site</label>
                                            </div>
                                            <Form.Control disabled={!affliatePermission} type="text" value={formAffiliate.website} className={validation.website != null ? ("error-form-add") : ("")} onChange={e => setFormAffiliate({ ...formAffiliate, website: e.target.value })} style={{ width: "100%", padding: 4, borderColor: "rgba(0, 0, 0, 0.2)", borderRadius: 3 }} />
                                        </Form.Group>
                                    </Form>
                                    {
                                        validation.website !== null ? (
                                            <div class="invalid-feedback loginForm">
                                                {validation.website}
                                            </div>
                                        ) : (
                                            <></>
                                        )
                                    }
                                </Col>

                            </Row>

                            <Row style={{ marginTop: 10, paddingBottom: 10 }} className="justify-content-start mt-2 me-auto w-75 form-add-aff">
                                <Col lg={4} md={4} sm={4}>
                                    <div className='form-aff-list-in'>
                                        <div style={{ marginBottom: 3 }} className='form-aff-list-in-lab'>
                                            <label>Language</label>
                                        </div>
                                        <div className="dashboard-select-periode" style={{ maxWidth: "100%" }}>
                                            <Select isDisabled={!affliatePermission} options={ltLang} onChange={e => setFormAffiliate({ ...formAffiliate, language: e.value })} />
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} md={4} sm={5}>
                                    <div className='form-aff-list-in'>
                                        <div style={{ marginBottom: 3 }} className='form-aff-list-in-lab'>
                                            <label>Country</label>
                                        </div>
                                        <div className="dashboard-select-periode" style={{ maxWidth: "100%" }}>
                                            <Select isDisabled={!affliatePermission} options={ltCount} onChange={e => setFormAffiliate({ ...formAffiliate, country: e.value })} />
                                        </div>
                                    </div>
                                    {
                                        validation.country !== null ? (
                                            <div class="invalid-feedback loginForm">
                                                {validation.country}
                                            </div>
                                        ) : (
                                            <></>
                                        )
                                    }
                                </Col>

                            </Row>


                            <Row style={{ marginTop: 10, paddingBottom: 10 }} className="justify-content-start mt-2 me-auto w-75 form-add-aff">
                                <Col lg={8} md={4} sm={4}>
                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", fontWeight: "500" }}>
                                        <div style={{ marginBottom: 3 }} className='form-aff-list-in-lab'>
                                            <label>Note</label>
                                        </div>
                                        <Form.Control disabled={!affliatePermission} rows={3} name="textarea" accepter={Textarea} value={formAffiliate.note} style={{ borderColor: "rgba(0,0,0,0.2)", borderRadius: 3 }} onChange={e => setFormAffiliate({ ...formAffiliate, note: e.target.value })} />

                                    </div>
                                </Col>
                            </Row>


                            <Row className="justify-content-start  me-auto w-100 mt-4">
                                <Col lg={4} md={4} sm={4}>
                                    <div className='form-aff-list-in'>
                                        <div style={{ marginBottom: 3 }} className='form-aff-list-in-lab'>
                                            <label>Currency</label>
                                        </div>
                                        <div className="dashboard-select-periode " style={{ maxWidth: "100%" }}>
                                            <Select isDisabled={!affliatePermission} options={optionsCurrency} value={selectedCurrencyValue} onChange={e => setFormAffiliate({ ...formAffiliate, country: e.value })} />
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} md={4} sm={5}>
                                    <div className='form-aff-list-in'>
                                        <div style={{ marginBottom: 3 }} className='form-aff-list-in-lab'>
                                            <label>Commission group</label>
                                        </div>
                                        <div className="dashboard-select-periode" style={{ maxWidth: "100%" }}>
                                            <Select isDisabled={!affliatePermission} options={ltComGrp} onChange={e => setFormAffiliate({ ...formAffiliate, commissiongroup: e.value })} />
                                        </div>
                                    </div>
                                    {
                                        validation.commissiongroup !== null ? (
                                            <div class="invalid-feedback loginForm">
                                                {validation.commissiongroup}
                                            </div>
                                        ) : (
                                            <></>
                                        )
                                    }
                                </Col>
                                <Col lg={4} md={4} sm={5}>
                                    <div className='form-aff-list-in'>
                                        <div style={{ marginBottom: 3 }} className='form-aff-list-in-lab'>
                                            <label>Affiliate grourp</label>
                                        </div>
                                        <div className="dashboard-select-periode" style={{ maxWidth: "100%" }}>
                                            <Select isDisabled={!affliatePermission} options={ltAffGrp} onChange={e => setFormAffiliate({ ...formAffiliate, affiliategroup: e.value })} />
                                        </div>
                                    </div>
                                    {
                                        validation.affiliategroup !== null ? (
                                            <div class="invalid-feedback loginForm">
                                                {validation.affiliategroup}
                                            </div>
                                        ) : (
                                            <></>
                                        )
                                    }
                                </Col>
                                {/* <div style={{borderBottom:"1px dashed black",marginTop:"30px",width:"400px"}}></div> */}

                            </Row>

                            <Row className="justify-content-start mt-2 me-auto w-75 mb-5">
                                <Col lg={3} md={4} sm={5} className=" pt-3 md-se-btn">
                                    <Button disabled={!affliatePermission || affloading} style={{ fontWeight: 400 }} onClick={addAffiliate} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp">
                                        {
                                            affloading ? (
                                                <Spinner size="sm" />
                                            ) : (
                                                <>Add Affiliate</>
                                            )
                                        }
                                    </Button>
                                </Col>

                            </Row>

                        </Row>

                    </Container>
                </div>

            </div>
        </>
    )
}

export default AddAffliate